//libs
import React,{Component} from "react";
import {connect} from "react-redux";
import axios from 'axios';
//components
import Loading from "../../UI_Elements/Loading";
//other
import {setTrue} from "../../../actions/refresh";
import {post as createStation, put as updateStation, getGroupTypes} from "../../../actions/stations";
import {post as createWheelChanger, put as updateWheelChanger} from "../../../actions/wheelChangers";
import moment from 'moment'
import Config from "../../../config";
import {notification,isAdmin} from "../../../helpers";
import DateTimeField from "./Form_Elements/DateTimeField";

class EditLastOnRentDate extends Component {

    constructor(props) {
        super(props);

        this.state = {
            receivedDate:false,
            frictionDate: '',
            spikeDate: '',
            summerDate: '',
            defaultDates: {
                frictionDate: moment('2018-05-31'),
                spikeDate: moment('2018-04-15'),
                summerDate: moment('2018-10-31'),
            }
        };

        this.handleSubmit = this.handleSubmit.bind(this)
        this.handleFrictionChange = this.handleFrictionChange.bind(this)
        this.handleSpikeChange = this.handleSpikeChange.bind(this)
        this.handleSummerChange = this.handleSummerChange.bind(this)

        if (isAdmin()){
            this.getLastOnRentDate = this.getLastOnRentDate.bind(this)
            this.postLastOnRentDate = this.postLastOnRentDate.bind(this)
            this.getLastOnRentDate();
        }
    }

    handleSubmit(e) {
        e.preventDefault();
        this.postLastOnRentDate()
    }

    handleFrictionChange(id,date) {
        this.setState({
            frictionDate: date
        })
    }

    handleSpikeChange(id,date) {
        this.setState({
            spikeDate: date
        })
    }

    handleSummerChange(id,date) {
        this.setState({
            summerDate: date
        })
    }

    getLastOnRentDate() {

        if (!isAdmin()){
            return false;
        }
        axios.get(Config.api.getDomain() + 'wheel/getLastOnRent', Config.api.getConfig()).then(res => {

                if (res.data.length > 0) {

                    let frictionDate= this.state.defaultDates.frictionDate;
                    let spikeDate=this.state.defaultDates.spikeDate;
                    let summerDate=this.state.defaultDates.summerDate;

                    res.data.forEach(wheel => {
                        if (parseInt(wheel.wheelType,10) === 3 || wheel.wheelType === 'WinterFriction'){
                            frictionDate=moment(wheel.lastOnRentDate);
                        }
                        if (parseInt(wheel.wheelType,10) === 2 || wheel.wheelType === 'WinterDubb') {
                            spikeDate=moment(wheel.lastOnRentDate);
                        }

                        if (parseInt(wheel.wheelType,10) === 1 || wheel.wheelType === 'Summer') {
                            summerDate=moment(wheel.lastOnRentDate);
                        }
                    });

                    this.setState({
                        frictionDate:frictionDate,
                        spikeDate:spikeDate,
                        summerDate:summerDate,
                        receivedDate:true
                    });


                } else {
                    this.setState({
                        frictionDate: this.state.defaultDates.frictionDate,
                        spikeDate: this.state.defaultDates.spikeDate,
                        summerDate: this.state.defaultDates.summerDate,
                        receivedDate:true
                    })
                }
            }).catch(error => {

                this.setState({
                    frictionDate: this.state.defaultDates.frictionDate,
                    spikeDate: this.state.defaultDates.spikeDate,
                    summerDate: this.state.defaultDates.summerDate,
                    receivedDate:true
                });
            })
    }

    postLastOnRentDate() {

        if (!isAdmin()){
            return false;
        }
        let frictionDate = moment(this.state.frictionDate).format('YYYY-MM-DD');
        let dubDate = moment(this.state.spikeDate).format('YYYY-MM-DD');
        let summerDate = moment(this.state.summerDate).format('YYYY-MM-DD');
        if (frictionDate==="Invalid date" || dubDate==="Invalid date" || summerDate==="Invalid date"){
            notification("Tyvärr, datumet är felaktigt format, kan inte uppdateras!");
            return false;
        }


        const data = [
            {
                wheelType: 'WinterFriction',
                lastOnRentDate: frictionDate
            },
            {
                wheelType: 'WinterDubb',
                lastOnRentDate: dubDate
            },
            {
                wheelType: 'Summer',
                lastOnRentDate: summerDate
            }
        ]

        axios.post(Config.api.getDomain() + 'wheel/updateLastOnRent', data, Config.api.getConfig())
            .then(response => {
                notification("Datum sparades!");
            })
            .catch(error => {
                notification("Datum sparades inte!");
            })
    }

    handleDateChangeRaw(e){
        e.preventDefault()
    }

    render() {

        if (!isAdmin()){
            return null;
        }

        if (!this.state.receivedDate){
            return (
                <div className='box edit-last-on-rent-date'>
                    <div className='box-inner'>
                        <Loading show={true}/>
                    </div>
                </div>
            )

        }
        let buttonTitle="Redigera last on rent date";

        let friction = (
            <DateTimeField
                title={"Friction"}
                name='frictionDate'
                id='frictionDate'
                value={new Date(this.state.frictionDate)}
                onChange={(id,date)=>this.handleFrictionChange(id,date)}
            />
        );

        let spike = (
            <DateTimeField
                title={"Spike"}
                name='spikeDate'
                id='spikeDate'
                value={new Date(this.state.spikeDate)}
                onChange={(id,date)=>this.handleSpikeChange(id,date)}
            />
        );

        let summer = (
            <DateTimeField
                title={"Summer"}
                name='summerDate'
                id='summerDate'
                value={new Date(this.state.summerDate)}
                onChange={(id,date)=>this.handleSummerChange(id,date)}
            />
        );

        return (
            <div className='box edit-last-on-rent-date'>
                <div className='box-inner'>
                    <h2>{buttonTitle}</h2>
                    <form onSubmit={this.handleSubmit}>

                        <div className='date'>

                            {friction}

                            {spike}

                            {summer}
                        
                        </div>

                        <input
                            disabled={typeof(this.state.groupType)==="undefined" &&  this.state.groupType==="Ingen"}
                            type="submit"
                            className="submit creategroupsubmit form-submit"
                            value={buttonTitle}
                        />
                    </form>

                </div>
            </div>
        );
    }
}

/**
 * Map state to properties
 */
const mapStateToPropsForEditLastOnRentDate = (state) => {
    return {
        refresh: state.refresh,
        submitting: state.stations.submitting,
        groupTypes: state.stations.groupTypes,
        groups: state.stations.groups
    };
};

/**
 * Map actions to properties
 */
const mapDispatchToPropsForEditLastOnRentDate = (dispatch) => {
    return {
        setTrue: (key) => dispatch(setTrue(key)),
        createStation:(data) => dispatch(createStation(data)),
        createWheelChanger:(data) => dispatch(createWheelChanger(data)),
        getGroupTypes:()=>dispatch(getGroupTypes()),
        updateStation:(data) => dispatch(updateStation(data)),
        updateWheelChanger:(data) => dispatch(updateWheelChanger(data))
    };
};

/**
 * Create groups
 */
export default connect(mapStateToPropsForEditLastOnRentDate, mapDispatchToPropsForEditLastOnRentDate)(EditLastOnRentDate);


// WEBPACK FOOTER //
// ./src/components/UI_Elements/Forms/EditLastOnRentDate.js